import tw from 'twin.macro';

const DateLabelBig = tw.div`text-sm text-gray-600`;

export default DateLabelBig;
